import React from 'react'
// Styles
import * as styles from './Empty.module.css'

const Empty: React.FC = ({}) => {
    return <div className={styles.empty}>Escribe para empezar la búsqueda</div>
}

export default Empty
